// in src/users.js
import {makeStyles, Theme} from '@material-ui/core';
import React from 'react';
import {ChipField, Create, ReferenceArrayInput, ReferenceInput, required, SelectArrayInput, SelectInput, Toolbar, SimpleForm} from 'react-admin';
import {HASHTAG_CATEGORY, HASHTAG_CATEGORY_LIST, HASHTAG_MULTIPLE_LIST, HASH_TAG} from '../../consts/Names';
import { SaveWithCreateButton } from '../utils/RecordWrappers';

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },
   formContainer: {
      padding: '1em 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   }
}));

export const CreateToolbar = (props) => {
   const {className} = props;
   return(
   <Toolbar {...props} className={className}>
      <SaveWithCreateButton replaceFunction={reworkedData} updatedSource={HASHTAG_CATEGORY_LIST.SOURCE} redirect={`/${HASHTAG_CATEGORY_LIST.SOURCE}/`} 
      submitOnEnter={false} variant="text"  undoable={false} />      
   </Toolbar>
)}

const reworkedData = (props) => {
   props.image = "";
   return props;
} 

export const HashTagsForCategoryCreate = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} title="Create tags list for category">
         <SimpleForm className={classes.formContainer} redirect="list" toolbar={<CreateToolbar {...props}/>}>
            <ReferenceInput
               className={classes.textFld}
               label="Category"
               perPage={1000}
               source={HASHTAG_CATEGORY_LIST.category_id}
               reference={HASHTAG_CATEGORY.SOURCE}
               validate={[required()]}>
               <SelectInput optionText="name" />
            </ReferenceInput>
            {/* <ImageInput
               className={classes.imageFld}
               source={HASHTAG_CATEGORY_LIST.image}
               label="Thumbnail image"
               accept="image/*"
               validate={[required()]}
               placeholder={<p>Drop your image here</p>}>
               <ImageField source="src" title="title" />
            </ImageInput> */}
            <ReferenceArrayInput className={classes.textFld} label="Related tags" reference={HASH_TAG.SOURCE} source={HASHTAG_MULTIPLE_LIST.ids} 
            perPage={1000}
            validate={[required()]}>
               <SelectArrayInput>
                  <ChipField />
               </SelectArrayInput>
            </ReferenceArrayInput>
         </SimpleForm>
      </Create>
   );
};
